module.exports = __webpack_public_path__ + "img/pass_bad.c4cafa6b.svg";